/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IICD10Procedure } from 'app/shared/model/icd-10-procedure.model';
import { IICD10Diagnosis } from 'app/shared/model/icd-10-diagnosis.model';
import { IAppointments } from 'app/shared/model/appointments.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { AdmissionType } from 'app/shared/model/enumerations/admission-type.model';

export interface IAdmissionAdvice {
  id?: string;
  procedureSNId?: string | null;
  procedureSNText?: string | null;
  adviseNotes?: string;
  instructions?: string;
  snomedConceptId?: string;
  snomedConceptText?: string;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  fulfilled?: boolean | null;
  emergency?: boolean | null;
  highRisk?: boolean | null;
  modifiedByType?: keyof typeof AddedByType | null;
  modifiedByID?: string;
  emAdmissionId?: string | null;
  type?: keyof typeof AdmissionType | null;
  proposedProcedure?: IICD10Procedure | null;
  diagnosis?: IICD10Diagnosis;
  appointment?: IAppointments | null;
  advicedBy?: IDoctor;
  patient?: IGlucoUser;
  admitAt?: IHospital;
}

export const defaultValue: Readonly<IAdmissionAdvice> = {
  active: false,
  fulfilled: false,
  emergency: false,
  highRisk: false,
};
